import React from 'react';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
import WorkWithMe from '../components/WorkWithMe';

const Home = () => {
  return (
    <div>
      <Hero />
      <AboutSection />
      <WorkWithMe />
    </div>
  );
};

export default Home;
